









































































import EpigraphyImage from '@/views/Texts/EpigraphyView/EpigraphyDisplay/components/EpigraphyImage.vue';
import PhotoSelector from './components/PhotoSelector.vue';
import {
  defineComponent,
  ref,
  computed,
  watch,
  ComputedRef,
} from '@vue/composition-api';
import { EpigraphyLabelLink, TextPhoto } from '@oare/types';
import { v4 } from 'uuid';
import sl from '@/serviceLocator';

export default defineComponent({
  components: {
    EpigraphyImage,
    PhotoSelector,
  },
  props: {
    inDialog: {
      type: Boolean,
      default: false,
    },
  },
  setup(_, { emit }) {
    const store = sl.get('store');

    const photos = ref<TextPhoto[]>([]);

    const confirmed = ref(false);

    const setPhotoDetails = (photo: TextPhoto) => {
      const existingUuids = photos.value.map(upload => upload.uuid);

      if (existingUuids.includes(photo.uuid)) {
        photos.value.splice(existingUuids.indexOf(photo.uuid), 1, photo);
      } else {
        photos.value.push(photo);
      }
    };

    const photosWithUrl = computed(() =>
      photos.value.filter(photo => photo.url)
    );

    const photoUrls: ComputedRef<EpigraphyLabelLink[]> = computed(() => {
      return photosWithUrl.value.map(photo => ({
        link: photo.url || '',
        label: `${store.getters.user!.firstName} ${
          store.getters.user!.lastName
        }`,
        side: photo.side || null,
        view: photo.view || null,
      }));
    });

    const addPhoto = () => {
      photos.value.push({
        uuid: v4(),
      });
    };

    const removePhoto = (uuid: string) => {
      photos.value = photos.value.filter(photo => photo.uuid !== uuid);
    };

    watch(
      photos,
      () => {
        emit('update-photos', photos.value);
      },
      { deep: true }
    );

    const stepComplete = computed(
      () =>
        photos.value.every(photo => photo.url && photo.side && photo.view) &&
        confirmed.value
    );

    watch(stepComplete, () => {
      emit('step-complete', stepComplete.value);
    });

    return {
      photos,
      photoUrls,
      setPhotoDetails,
      addPhoto,
      removePhoto,
      photosWithUrl,
      confirmed,
    };
  },
});
